import { useForm } from "react-hook-form";
import FormTextField, {
  emailValidationPattern,
  passwordValidationPattern,
} from "../components/formComponents/FormTextField";
import AsyncLoadingButton from "../components/asyncLoadingButton/AsyncLoadingButton";
import { auth } from "../auth/auth";
import type { FC } from "react";
import { Link as RouterLink } from "react-router-dom";
import { Link } from "@mui/material";

interface EmailPasswordLoginFormState {
  readonly email: string;
  readonly password: string;
}

interface Props {
  readonly onLoginSuccess: () => void | Promise<void>;
  readonly onLoginFailed: (error: unknown) => void;
}

const EmailPasswordLogin: FC<Props> = ({ onLoginSuccess, onLoginFailed }) => {
  const { control, handleSubmit } = useForm<EmailPasswordLoginFormState>({
    defaultValues: { email: "", password: "" },
  });

  const onSubmit = async (email: string, password: string) => {
    try {
      await auth.signInWithEmailAndPassword(email, password);
      await onLoginSuccess();
    } catch (error) {
      onLoginFailed(error);
    }
  };

  return (
    <>
      <FormTextField
        type="email"
        name="email"
        label="Email"
        control={control}
        rules={{ pattern: emailValidationPattern }}
      />
      <FormTextField
        type="password"
        name="password"
        label="Hasło"
        control={control}
        rules={{ pattern: passwordValidationPattern }}
      />
      <AsyncLoadingButton onClick={handleSubmit((s) => onSubmit(s.email, s.password))}>Zaloguj</AsyncLoadingButton>
      <Link component={RouterLink} to={`/reset-password`}>
        Nie pamiętasz hasła?
      </Link>
    </>
  );
};

export default EmailPasswordLogin;
